import { ParameterizedRouteDefinition, StaticRouteDefinition, route } from '@betterment/js-runtime';
import { matchPath } from 'react-router-dom';

/**
 * Utility that wraps route() to build navigation routes that preserve `/:employer_id`
 *
 * @param components - An array of strings or objects with a `param` property. the same as route(_, components)
 */
type Param<P> = { param: P };
type Component<P> = string | Param<P>;
export function employerScopedRoute(components: string[]): StaticRouteDefinition;
export function employerScopedRoute<P extends string>(components: Component<P>[]): ParameterizedRouteDefinition<P>;
export function employerScopedRoute<P extends string>(components: string[] | Component<P>[]) {
  const windowLocationMatch = matchPath('/employers/:employerId/*', window.location.pathname);
  const employerId = windowLocationMatch?.params.employerId;

  if (employerId) {
    return route('', ['employers', employerId, ...components]);
  }

  return route('', components);
}

export function buildAppPath(path: string, params?: Record<string, string>) {
  const query = params ? `?${new URLSearchParams(params).toString()}` : '';
  return `${path}${query}`;
}

export function navigate(path: string, params?: Record<string, string>) {
  window.location.assign(buildAppPath(path, params));
}
